//export const API_URL = process.env.REACT_APP_API + "/api";
export const API_URL = process.env.REACT_APP_API;

export const SIGNOUT_API_URL =
  process.env.REACT_APP_API + "/api/signout-microsoft-hub";

export const SIGNIN_API_URL = API_URL + "/api/account/external-login";

export const VERIFY_API_URL = API_URL + "/api/verify-mfa";
